
/* System defined core library */
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
/* User defined library/components */
import { SelectedExamDetailService } from './shared/services/selected-exam-detail.service';

/* User defined models */
import { AppointmentDetail } from '../shared/models/scheduling/appointmentdetail.model';
import { Program } from '../shared/models/scheduling/program.model';


@Component({
  selector: 'app-scheduling',
  templateUrl: './scheduling.component.html'
})
export class SchedulingComponent implements OnInit {
  public isTargetAppointmentlkup: boolean;
  appointmentDetailData$: Subscription;
  program: Program;
  program$: Subscription;
  selectedAppointmentDetails: AppointmentDetail[];



  constructor(private selectedExamDetailService: SelectedExamDetailService, private router: Router) {
    this.appointmentDetailData$ = selectedExamDetailService.selectedAppointmentDetails.subscribe(
      appointDetailData => {
        this.selectedAppointmentDetails = appointDetailData;
      });

    this.program$ = selectedExamDetailService.program.subscribe(
      program => {
        this.program = program;
      }
    )
  }

  ngOnInit() {
    if (this.router.url.indexOf("appointmentsearch") > -1 || this.router.url.indexOf("locationselection") > -1 || this.router.url.indexOf("rescheduleappointment") > -1 || this.router.url.indexOf("cancelappointment") > -1) {
      this.isTargetAppointmentlkup = true;
    }
    else {
      this.isTargetAppointmentlkup = false;
    }


  }

  getClass() {
    let programCode = this.selectedExamDetailService.programCode ? this.selectedExamDetailService.programCode.toLowerCase() : '';
    let clientCode = this.selectedExamDetailService.clientCode ? this.selectedExamDetailService.clientCode.toLowerCase() : '';
    return `body-wrpr view-body-wrpr text-left h-100 body-wrpr-${programCode} body-wrpr-${clientCode}`;

  }

  ngOnDestroy() {

  }

}
